import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    images: [], // Each image is an object: { name, size, url }
    currentSlideIndex: 0,
};

/**
 * In this slice, presentations are managed in the form of 
 * individual images that serve as slides. 
 * They can be added or removed. The sequence can be defined. 
 * The images can be displayed in the web app and sent to Unity.
 */
const presentationSlice = createSlice({
    name: 'presentation',
    initialState,
    reducers: {
        addImages: (state, action) => {
            const newImages = action.payload.filter(newImage =>
                !state.images.some(existingImage =>
                    existingImage.name === newImage.name &&
                    existingImage.size === newImage.size
                )
            );
            state.images = [...state.images, ...newImages];
        },
        reorderImages: (state, action) => {
            state.images = action.payload;
        },
        removeImage: (state, action) => {
            state.images = state.images.filter((_, index) => index !== action.payload);
        },
        resetImages: (state) => {
            state.images = [];
            state.currentSlideIndex = 0;
        },
        setCurrentSlide: (state, action) => {
            state.currentSlideIndex = action.payload;
        },
    },
});

export const { addImages, reorderImages, resetImages, removeImage, setCurrentSlide } = presentationSlice.actions;
export const selectImages = (state) => state.presentation.images;
export const selectCurrentSlideIndex = (state) => state.presentation.currentSlideIndex;

export default presentationSlice.reducer;
